export function formatTimestamp(timestamp) {
    const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    var dateString = new Date(timestamp)
    return MONTHS[dateString.getMonth()]
}

var SCORE_CAP = 4

export var AVG_LEXILE_LEVEL = "average_lexile_level"
export var TOTAL_QUIZZES = "total_quizzes"
export var FAILED_QUIZZES = "failed_quizzes"
export var PASSED_QUIZZES = "passed_quizzes"
export var FLAGGED_QUIZZES = "flagged_quizzes"
export var TOTAL_WITH_LEXILE = 'total_with_lexile'
export var AVG_QUIZ_SCORE = "average_quiz_score"
export var DAYS_ACTIVE = "days_active"
export var EXCERCISES_COMPLETED = "excercises_completed"
export var MINUTES_LOGGED = "minutes_logged"
export var PAGES_LOGGED = "pages_logged"
export var TOTAL_PRACTICE_QUESTIONS = "total_practice_questions"
export var TOTAL_QUESTION_BUILDERS = "total_question_builders"
export var TOTAL_REVIEWS = "total_reviews"
export var TOTAL_EVALUATED_ANSWERS = 'total_evaluated_answers'
export var AVG_ANSWER_SCORE = 'average_answer_score'

export var QUIZ_PERFORMANCE = 'quiz_performance'
// all non-rubric activity metrics
export var ACTIVITY_METRICS = [QUIZ_PERFORMANCE, PASSED_QUIZZES, FAILED_QUIZZES, TOTAL_QUIZZES, FLAGGED_QUIZZES, EXCERCISES_COMPLETED, MINUTES_LOGGED, PAGES_LOGGED, TOTAL_PRACTICE_QUESTIONS, TOTAL_QUESTION_BUILDERS, TOTAL_REVIEWS, AVG_LEXILE_LEVEL]

export var MECH_CAPS = 'comm-conv-mech-caps-4'
export var MECH_GRAM = 'comm-conv-mech-gram-5'
export var MECH_PUNC = 'comm-conv-mech-punc-8'
export var MECH_SPELL = 'comm-conv-mech-spell-13'
export var ORG_WORD_COUNT = 'comm-conv-org-word-count-18'
export var ORG_SENT_COUNT = 'comm-conv-org-sent-count-11'
export var ORG_SENT_STRUCT = 'comm-conv-org-sent-struct-coso-12'

export var READ_THE_BOOK = 'crit-evi-cote-bert-read-book-1'
export var TEXT_DETAIL_QUANT = 'crit-evi-cote-bert-quantity-14'
export var TEXT_DETAIL_QUAL =  'crit-evi-cote-bert-quality-17'
export var RESTATING = 'crit-rc-atq-cors-bert-10'
export var ANSWER_PRESENT = 'crit-rc-atq-coqa-answer-present-3'
export var FULLY_ANSWERED =  'crit-rc-atq-coqa-fully-answered-2'

export var RUBRIC_METRICS = [READ_THE_BOOK, TEXT_DETAIL_QUANT, RESTATING, ANSWER_PRESENT, FULLY_ANSWERED, MECH_CAPS, MECH_GRAM, MECH_PUNC, MECH_SPELL, ORG_WORD_COUNT, ORG_SENT_COUNT]

var POSITIVE_RUBRIC_LABELS = ['yes', 'correct', 'sufficient', 'solid', "specific/applicable"]
var NEUTRAL_RUBIC_LABELS = ['developing']
var NEGATIVE_RUBRIC_LABELS = ['no', '-', 'incorrect', 'insufficient', "unspecific/nonapplicable"]

export var STUDENT = 'student'
export var STUDENT_LIST = 'student_list'
export var TEACHER = 'teacher'
export var SCHOOL_ORG = 'school_org'
export var DISTRICT_ORG = 'district_org'

export var STAT_DISPLAY = {
    [AVG_QUIZ_SCORE] : {
        'unit': '',
        'formatting': (score)=>{
            var rounded = parseFloat(score) * SCORE_CAP
            return rounded.toFixed(2)
        },
        'name': "Avg. Quiz Score",
        'domain': [0,4]
    },
    [AVG_ANSWER_SCORE]: {
        'unit': '',
        'formatting': (score)=>{
            var rounded = parseFloat(score) * SCORE_CAP
            return rounded.toFixed(2)
        },
        'name': "Avg. Answer Score",
        'domain': [0,4]
    },
    [TOTAL_QUIZZES]: {
        'name': 'Total Quizzes'
    },
    [PASSED_QUIZZES]: {
        'name': "Quizzes Passed"
    },
    [FAILED_QUIZZES]: {
        'name': "Quizzes Failed"
    },
    [MINUTES_LOGGED]:{
        'name': "Minutes Logged",
    },
    [PAGES_LOGGED]:{
        'name': "Pages Logged",
    },
    [EXCERCISES_COMPLETED]:{
        'name': "Excercises Completed"
    },
    [TOTAL_REVIEWS]:{
        'name': "Reviews Completed"
    },
    [FLAGGED_QUIZZES]:{
        'name': "Quizzes Flagged"
    },
    [TOTAL_PRACTICE_QUESTIONS]:{
        'name': "Practice Questions Completed"
    },
    [TOTAL_QUESTION_BUILDERS]:{
        'name': "Total Question Builders"
    },
    [AVG_LEXILE_LEVEL]:{
        'name': "Average Lexile Level",
    }, 
    [QUIZ_PERFORMANCE]:{
        'name': "Quiz Performance",
        'data_extraction_func': (digest, data)=>{
            data["Quizzes Passed"] = digest.data[PASSED_QUIZZES]
            data["Quizzes Failed"] = digest.data[FAILED_QUIZZES]
            return data
        }
    },
    [READ_THE_BOOK]:{
        'name': "Read the Book",
        'data_extraction_func': (digest, data)=>{
            var displayName = STAT_DISPLAY[READ_THE_BOOK].name
            var score = calculateRubricScore(digest, READ_THE_BOOK)
            data[displayName] = score.toFixed(2)
            return data
        },
        'unit': "%"
    },
    [TEXT_DETAIL_QUANT]:{
        'name': "Text Detail Quantity",
        'data_extraction_func': (digest, data)=>{
            var displayName = STAT_DISPLAY[TEXT_DETAIL_QUANT].name
            var score = calculateRubricScore(digest, TEXT_DETAIL_QUANT)
            data[displayName] = score.toFixed(2)
            return data
        },
        'unit': "%"
    },
    [RESTATING]:{
        'name': "Question Restated",
        'data_extraction_func': (digest, data)=>{
            var displayName = STAT_DISPLAY[RESTATING].name
            var score = calculateRubricScore(digest, RESTATING)
            data[displayName] = score.toFixed(2)
            return data
        },
        'unit': "%"
    },
    [ANSWER_PRESENT]:{
        'name': "Question Answered",
        'data_extraction_func': (digest, data)=>{
            var displayName = STAT_DISPLAY[ANSWER_PRESENT].name
            var score = calculateRubricScore(digest, ANSWER_PRESENT)
            data[displayName] = score.toFixed(2)
            return data
        },
        'unit': "%"
    },
    [FULLY_ANSWERED]:{
        'name': "Fully Answered",
        'data_extraction_func': (digest, data)=>{
            var displayName = STAT_DISPLAY[FULLY_ANSWERED].name
            var score = calculateRubricScore(digest, FULLY_ANSWERED)
            data[displayName] = score.toFixed(2)
            return data
        },
        'unit': "%"
    },
    [MECH_CAPS]:{
        'name': "Capitalization",
        'data_extraction_func': (digest, data)=>{
            var displayName = STAT_DISPLAY[MECH_CAPS].name
            var score = calculateRubricScore(digest, MECH_CAPS)
            data[displayName] = score.toFixed(2)
            return data
        },
        'unit': "%"
    },
    [MECH_GRAM]:{
        'name': "Grammar",
        'data_extraction_func': (digest, data)=>{
            var displayName = STAT_DISPLAY[MECH_GRAM].name
            var score = calculateRubricScore(digest, MECH_GRAM)
            data[displayName] = score.toFixed(2)
            return data
        },
        'unit': "%"
    },
    [MECH_PUNC]:{
        'name': "Punctuation",
        'data_extraction_func': (digest, data)=>{
            var displayName = STAT_DISPLAY[MECH_PUNC].name
            var score = calculateRubricScore(digest, MECH_PUNC)
            data[displayName] = score.toFixed(2)
            return data
        },
        'unit': "%"
    },
    [MECH_SPELL]:{
        'name': "Spelling",
        'data_extraction_func': (digest, data)=>{
            var displayName = STAT_DISPLAY[MECH_SPELL].name
            var score = calculateRubricScore(digest, MECH_SPELL)
            data[displayName] = score.toFixed(2)
            return data
        },
        'unit': "%"
    },
    [ORG_WORD_COUNT]:{
        'name': "Word Count",
        'data_extraction_func': (digest, data)=>{
            var displayName = STAT_DISPLAY[ORG_WORD_COUNT].name
            var score = calculateRubricScore(digest, ORG_WORD_COUNT)
            data[displayName] = score.toFixed(2)
            return data
        },
        'unit': "%"
    },
    [ORG_SENT_COUNT]:{
        'name': "Sentence Count",
        'data_extraction_func': (digest, data)=>{
            var displayName = STAT_DISPLAY[ORG_SENT_COUNT].name
            var score = calculateRubricScore(digest, ORG_SENT_COUNT)
            data[displayName] = score.toFixed(2)
            return data
        },
        'unit': "%"
    }
}

// calculate percentage of successful attempts at a rubric item.
export function calculateRubricScore(digest, rubric){
    var rubricResults = _.get(digest, ['data', 'rubrics', rubric], {})
    var positiveOutcomes = 0
    var negativeOutcomes = 0
    _.each(rubricResults, (count, label)=>{
        if (POSITIVE_RUBRIC_LABELS.includes(label)) {positiveOutcomes += count}
        else {negativeOutcomes += count}
    })

    //make a percentage
    var correctPercentage = positiveOutcomes / (negativeOutcomes + positiveOutcomes) * 100
    return correctPercentage || 0
}

export function consolidateMonthlyRubrics(digests){
    // consolidated, mock digest.
    var consolidatedData = {'data': {'rubrics': {}}}

    digests.forEach(digest=>{
        Object.keys(digest.data.rubrics).forEach(rubric=>{
            if (!consolidatedData.data.rubrics[rubric]) {consolidatedData.data.rubrics[rubric] = {}}
            Object.keys(digest.data.rubrics[rubric]).forEach(label=>{
                if (!consolidatedData.data.rubrics[rubric][label]) {consolidatedData.data.rubrics[rubric][label] = 0}
                consolidatedData.data.rubrics[rubric][label] += 1
            })
        })
    })

    return consolidatedData
}

export function getEntityName(entityType, entity){
    if ([STUDENT, TEACHER].includes(entityType)){
        return `${entity.first_name} ${entity.last_name}`
    } else {
        return entity.name
    }
}

export var getBarColors = (metricsToGraph) => {
    const STANDARD_COLORS = ["#00a0f4", "#2b9401"]
    // want to color bars red and green for quiz performance stat.
    if (metricsToGraph.length <= 1) { return STANDARD_COLORS }
    
    // standard blue and green.
    const PASS_FAIL_COLORS = {"Quizzes Passed": '#42af14', "Quizzes Failed": '#ff7346'}
    
    // used to keep track of the standard color
    var standardColorIndex = 0
    var orderedColors = []
    for (var i = 0; i < metricsToGraph.length; i++){
        var metric = metricsToGraph[i]
        // if pass-fail
        if (PASS_FAIL_COLORS[metric]) {
            orderedColors.push(PASS_FAIL_COLORS[metric])
        } else { // if standard metric, grab color from normal list
            orderedColors.push(STANDARD_COLORS[standardColorIndex % STANDARD_COLORS.length])
            standardColorIndex += 1
        }
    }
    return orderedColors
}


// WEBPACK FOOTER //
// ./modules/components/data/graphs/GraphUtility.js